import api from './api'
import type { ApiResponse } from '../types/api'

export interface Vehicle {
  id: number
  brand: string
  model: string
  color: string
  year: number
  photo?: string
  height?: number
  weight?: number
  length?: number
  width?: number
  observations?: string
  fuelType: string
  registrationPlate: string
  lastRevisionDate?: string | null
  lastRevisionKm?: number | null
  revisionIntervalKm?: number | null
  revisionIntervalMonths?: number | null
  currentOdometerKm?: number | null
}

export type RevisionUrgency = 'NO_PLAN' | 'MISSING_LAST' | 'OVERDUE' | 'DUE_SOON' | 'UPCOMING'

export interface VehicleRevisionAlert {
  vehicleId: number
  registrationPlate: string
  brand: string
  model: string
  urgency: RevisionUrgency
  summary: string
  nextRevisionKm?: number | null
  nextRevisionDate?: string | null
  daysUntilDueDate?: number | null
  kmUntilDue?: number | null
}

export interface VehicleRevisionPlanBody {
  lastRevisionDate?: string
  lastRevisionKm?: number
  revisionIntervalKm?: number
  revisionIntervalMonths?: number
  currentOdometerKm?: number
  /** When true, server clears last km and km interval on the vehicle. */
  clearKmBasedPlan?: boolean
}

export const vehicleService = {
  async getById(id: number): Promise<Vehicle> {
    const response = await api.get<Vehicle>(`/vehicles/${id}`)
    return response.data
  },

  async getByRegistrationPlate(registrationPlate: string): Promise<Vehicle | null> {
    try {
      const response = await api.get<Vehicle>(`/vehicles/registration-plate/${registrationPlate}`)
      return response.data
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null
      }
      throw error
    }
  },

  async getRevisionAlerts(workshopCompanyId?: number): Promise<VehicleRevisionAlert[]> {
    const response = await api.get<ApiResponse<VehicleRevisionAlert[]>>('/vehicles/revision-alerts', {
      params: workshopCompanyId != null ? { workshopCompanyId } : undefined,
    })
    return response.data.data ?? []
  },

  async patchRevisionPlan(vehicleId: number, body: VehicleRevisionPlanBody): Promise<Vehicle> {
    const response = await api.patch<ApiResponse<Vehicle>>(`/vehicles/${vehicleId}/revision-plan`, body)
    if (!response.data.data) {
      throw new Error(response.data.message || 'Erro ao guardar plano de revisão')
    }
    return response.data.data
  },
}
